import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridRoluri = _resolveComponent("GridRoluri")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_GridDrepturiRoluri = _resolveComponent("GridDrepturiRoluri")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_GridRoluri, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            ($data.selectedRow !== null && $data.selectedRow !== undefined)
              ? (_openBlock(), _createBlock(_component_GridDrepturiRoluri, {
                  key: $data.selectedRow,
                  "rol-id": $data.selectedRow
                }, null, 8, ["rol-id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}